import React from 'react'

function GoogleMap() {
  return (
    <div className='w-full flex justify-center'>
        <iframe className='w-full lg:w-[720px] h-[450px]' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3682.8460056982995!2d120.38824151541895!3d22.622225036847375!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e1ba08fcf6043%3A0x546b04d081cbfa3b!2z5aSn5a-u!5e0!3m2!1szh-TW!2stw!4v1648022829330!5m2!1szh-TW!2stw" allowFullScreen="" loading="lazy"></iframe>   
    </div>
  )
}

export default GoogleMap